var map = {
	"./assets/clickable/angiesList.svg": "b8d1341e57e9564285d1",
	"./assets/disabled/angiesList.svg": "339bd2133cba857cb972",
	"./assets/original/angiesList.svg": "91b21a0c2a80bdee844f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84296f604021f5eadb51";